import { useEffect, useState } from "react";
import { Image } from "antd";
import { useTranslation } from "react-i18next";
import AddToCartButton from "../Button/AddToCart.jsx";

const ProductCard = ({
                         product,
                         buttonBackgroundColor,
                         isCart = false,
                         buttonBorderColor,
                         buttonTextColor,
                         categorySalesMap = {}
                     }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);

    const defaultPlaceholder = "https://dummyimage.com/300/eeeeee/000000.png&text=+";

    useEffect(() => {
        if (product) {
            setLoading(false);
        }
    }, [product]);

    if (loading) {
        return <div className="w-full h-64 bg-gray-200 animate-pulse" />;
    }

    if (!product) {
        return <div />;
    }

    const isInCategorySale = product.category && categorySalesMap[product.category];

    const activeSale = product.sale ?? isInCategorySale;

    const hasBasketSale = !!(product.basket_sale?.price && product.basket_sale?.discount);
    const discountedPrice = hasBasketSale
        ? product.basket_sale.price
        : activeSale?.price;

    const showBadge = activeSale?.name && activeSale?.discount != null && activeSale?.color;

    return (
        <div className="flex flex-col w-full h-full justify-between">
            <div className="mb-4">
                <Image
                    alt={product.name}
                    src={product.image}
                    fallback={defaultPlaceholder}
                    width="100%"
                    height={200}
                    style={{ objectFit: "contain" }}
                    preview={false}
                />
            </div>

            <div className="flex-grow flex flex-col justify-between">
                <div className="text-sm font-medium text-gray-900 text-left mb-2">
                    {product.name}
                </div>

                <div className="text-left mb-4">
                    {discountedPrice ? (
                        <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-2">
                <span className="text-sm line-through text-gray-400">
                  {t("price", { price: discountedPrice })}
                </span>
                                <span className="text-lg font-semibold text-gray-700">
                  {t("price", { price: product.price })}
                </span>
                            </div>

                            {showBadge && (
                                <div
                                    className="relative px-3 py-1 text-xs font-bold text-black"
                                    style={{
                                        backgroundColor: `#${product.sale.color}`,
                                        clipPath: "polygon(0% 0%, 2% 50%, 0% 100%, 100% 100%, 98% 50%, 100% 0%)",
                                    }}
                                >
                                    {`${product.sale.name} | -${product.sale.discount}%`}
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="text-lg font-semibold text-gray-700">
                            {t("price", { price: product.price })}
                        </div>
                    )}
                </div>
            </div>

            <AddToCartButton
                isCart={isCart}
                product={product}
                backgroundColor={buttonBackgroundColor}
                borderColor={buttonBorderColor}
                textColor={buttonTextColor}
            />
        </div>
    );
};


export default ProductCard;